"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStreamUpdatesV2 = handleStreamUpdatesV2;
const getOutcomeKey_1 = require("../../../getOutcomeKey");
const helpers_1 = require("../helpers");
const updateOutcome_1 = require("../updateOutcome");
const mapProbsToOutcomes_1 = require("../mapProbsToOutcomes");
const getOrderedOutcomeKeys_1 = require("../getOrderedOutcomeKeys");
const getCategoryMarketInfoFilteredTradingStatus_1 = require("../../getCategoryMarketInfoFilteredTradingStatus");
function handleStreamUpdatesV2(args) {
    var _a, _b, _c, _d, _e, _f;
    const { vMarketsInfo, vCategoriesInfo, sportId, eventMarkets, prevOutcomes, playersMap, probsWithPlayerIdParam = {}, marketsMap, eventStatus, clientType, eventCompetitors, vMarketIdsByMarket, vCategoriesSortedIds, } = args;
    const prevCategories = prevOutcomes.categories;
    const prevCategoriesIds = new Set(prevCategories.map(({ vCategoryId }) => vCategoryId));
    const prevMarkets = prevOutcomes.markets;
    // Переменная в которую мы будем складывать все пробсы для новых маркетов
    const newVirtualMarkets = {};
    const newVirtualCAtegories = {};
    const changedVirtualCategories = {};
    // переменные результата работы функции
    let categoriesChanged = false;
    const newMarkets = {};
    const changedMarkets = {};
    const deletedMarketsIds = new Set();
    for (const market of eventMarkets) {
        const checkOnExistance = new Set();
        const categoryExcluded = market.originalCategoryExcluded;
        // Так как в одном маркете может быть несколько виртуальных маркетов, трекаем изменения по каждому
        const changedVirtualMarkets = {};
        if (categoryExcluded) {
            // Помечаем все потенциальные виртуальные маркеты как удаленные
            for (const vmId of vMarketIdsByMarket[market.marketId]) {
                deletedMarketsIds.add(vmId);
                const { vCategoryId } = vMarketsInfo[vmId];
                if (vCategoryId !== undefined && prevCategoriesIds.has(vCategoryId)) {
                    if (changedVirtualCategories[vCategoryId] === undefined) {
                        changedVirtualCategories[vCategoryId] = {
                            newMarkets: new Set(),
                            deletedMarkets: new Set(),
                        };
                    }
                    changedVirtualCategories[vCategoryId].deletedMarkets.add(vmId);
                }
            }
            categoriesChanged = true;
            continue;
        }
        for (const probability of market.probabilities) {
            const outcomeKey = (0, getOutcomeKey_1.getOutcomeKey)(probability);
            if (probability.virtualMarketId === undefined ||
                probability.virtualMarketId === null) {
                checkOnExistance.add(outcomeKey);
                continue;
            }
            const vMarketInfo = vMarketsInfo[probability.virtualMarketId];
            if (vMarketInfo === undefined) {
                checkOnExistance.add(outcomeKey);
                continue;
            }
            const vCategoryInfo = vCategoriesInfo[vMarketInfo.vCategoryId];
            if (vCategoryInfo === undefined) {
                checkOnExistance.add(outcomeKey);
                continue;
            }
            const vMarketId = vMarketInfo.id;
            const vCategoryId = vCategoryInfo.id;
            // Новая категория
            if (!prevCategoriesIds.has(vCategoryId)) {
                // Фильтруем пробсы
                if ((0, helpers_1.probabilitySettled)(probability) ||
                    !(0, helpers_1.sportBelongsToCategory)(sportId, vCategoryInfo)) {
                    continue;
                }
                const hasPlayerIdParam = probsWithPlayerIdParam[outcomeKey] !== undefined;
                const unknownPlayer = playersMap[probsWithPlayerIdParam[outcomeKey]] === undefined;
                if (hasPlayerIdParam && unknownPlayer) {
                    continue;
                }
                // Выставляем флаг для пересчета категорий
                categoriesChanged = true;
                if (newVirtualMarkets[vMarketId] === undefined) {
                    newVirtualMarkets[vMarketId] = {};
                }
                newVirtualMarkets[vMarketId][outcomeKey] = probability;
                if (newVirtualCAtegories[vCategoryId] === undefined) {
                    newVirtualCAtegories[vCategoryId] = new Set();
                }
                newVirtualCAtegories[vCategoryId].add(vMarketId);
            }
            else if (prevMarkets[vMarketId] === undefined) {
                // Известная категория, но новый маркет
                if ((0, helpers_1.probabilitySettled)(probability) ||
                    !(0, helpers_1.sportBelongsToCategory)(sportId, vCategoryInfo)) {
                    continue;
                }
                const hasPlayerIdParam = probsWithPlayerIdParam[outcomeKey] !== undefined;
                const unknownPlayer = playersMap[probsWithPlayerIdParam[outcomeKey]] === undefined;
                if (hasPlayerIdParam && unknownPlayer) {
                    continue;
                }
                categoriesChanged = true;
                if (newVirtualMarkets[vMarketId] === undefined) {
                    newVirtualMarkets[vMarketId] = {};
                }
                newVirtualMarkets[vMarketId][outcomeKey] = probability;
                if (changedVirtualCategories[vCategoryId] === undefined) {
                    changedVirtualCategories[vCategoryId] = {
                        newMarkets: new Set(),
                        deletedMarkets: new Set(),
                    };
                }
                changedVirtualCategories[vCategoryId].newMarkets.add(vMarketId);
            }
            else {
                // Категория и маркет уже существовали ранее
                if (changedVirtualMarkets[vMarketId] === undefined) {
                    changedVirtualMarkets[vMarketId] = {
                        newProbs: {},
                        changedOutcomes: {},
                        deletedOutcomeKeys: new Set(),
                        recalcOrder: false,
                        recalcStatus: false,
                    };
                }
                const outcome = prevMarkets[vMarketId].outcomesByKey[outcomeKey];
                // Это новый пробс для маркета
                if (outcome === undefined) {
                    const terminatedStatus = (0, helpers_1.probabilitySettled)(probability);
                    const wrongSport = !(0, helpers_1.sportBelongsToCategory)(sportId, vCategoryInfo);
                    if (terminatedStatus || wrongSport) {
                        continue;
                    }
                    const hasPlayerIdParam = probsWithPlayerIdParam[outcomeKey] !== undefined;
                    const unknownPlayer = playersMap[probsWithPlayerIdParam[outcomeKey]] === undefined;
                    if (hasPlayerIdParam && unknownPlayer) {
                        continue;
                    }
                    changedVirtualMarkets[vMarketId].recalcStatus = true;
                    changedVirtualMarkets[vMarketId].recalcOrder = true;
                    changedVirtualMarkets[vMarketId].newProbs[outcomeKey] = probability;
                }
                else {
                    // Такой ауткам уже существовал
                    // Удаляем если он сейчас рассчитан
                    if ((0, helpers_1.probabilitySettled)(probability)) {
                        changedVirtualMarkets[vMarketId].deletedOutcomeKeys.add(outcomeKey);
                        changedVirtualMarkets[vMarketId].recalcStatus = true;
                        changedVirtualMarkets[vMarketId].recalcOrder = true;
                        continue;
                    }
                    // Помечаем флаг recalcStatus для будущего пересчета
                    if (changedVirtualMarkets[vMarketId].recalcStatus === false) {
                        if (probability.tradingStatus !== outcome.tradingStatus) {
                            changedVirtualMarkets[vMarketId].recalcStatus = true;
                        }
                    }
                    changedVirtualMarkets[vMarketId].changedOutcomes[outcomeKey] =
                        (0, updateOutcome_1.updateOutcome)(outcome, probability);
                }
            }
        }
        // проверяем нет ли в маркете помеченных на удаление неизвестных ауткамов
        if (checkOnExistance.size > 0) {
            const potentialVMarketIds = vMarketIdsByMarket[market.marketId];
            if (potentialVMarketIds === undefined) {
                continue;
            }
            // берем только те виртуальные маркеты которые потенциально могут быть по маркету
            for (const vMarketId of potentialVMarketIds) {
                if (prevMarkets[vMarketId]) {
                    for (const outcomeKey of checkOnExistance) {
                        if (prevMarkets[vMarketId].outcomesByKey[outcomeKey]) {
                            checkOnExistance.delete(outcomeKey);
                            if (changedVirtualMarkets[vMarketId] === undefined) {
                                changedVirtualMarkets[vMarketId] = {
                                    newProbs: {},
                                    changedOutcomes: {},
                                    deletedOutcomeKeys: new Set(),
                                    recalcOrder: false,
                                    recalcStatus: false,
                                };
                            }
                            changedVirtualMarkets[vMarketId].deletedOutcomeKeys.add(outcomeKey);
                        }
                    }
                }
            }
        }
        for (const [vMarketId, updates] of Object.entries(changedVirtualMarkets)) {
            // драфт нужен для того чтобы в дальшейшем при необходимости пересчитать статус и порядок
            const tempMarketChanges = {
                statusChanged: false,
                changedOutcomes: {},
            };
            const draft = { ...prevMarkets[vMarketId].outcomesByKey };
            if (Object.keys(updates.newProbs).length > 0) {
                const { marketId } = vMarketsInfo[vMarketId].filteredBy;
                const orderedOutcomeTypes = (_b = (_a = marketsMap[marketId]) === null || _a === void 0 ? void 0 : _a.orderedOutcomeTypes) !== null && _b !== void 0 ? _b : [];
                const newOutcomes = (0, mapProbsToOutcomes_1.mapProbabilitiesToOutcomes)({
                    probabilities: updates.newProbs,
                    vMarketInfo: vMarketsInfo[vMarketId],
                    players: playersMap,
                    clientType,
                    eventCompetitors,
                    orderedOutcomeTypes,
                });
                for (const [k, outcome] of Object.entries(newOutcomes)) {
                    draft[k] = outcome;
                    tempMarketChanges.changedOutcomes[k] = outcome;
                }
            }
            for (const [k, outcome] of Object.entries(updates.changedOutcomes)) {
                draft[k] = outcome;
                tempMarketChanges.changedOutcomes[k] = outcome;
            }
            for (const k of updates.deletedOutcomeKeys) {
                delete draft[k];
                if (tempMarketChanges.deletedOutcomesKeys === undefined) {
                    tempMarketChanges.deletedOutcomesKeys = new Set();
                }
                tempMarketChanges.deletedOutcomesKeys.add(k);
            }
            if (Object.keys(draft).length === 0) {
                categoriesChanged = true;
                deletedMarketsIds.add(vMarketId);
                const { vCategoryId } = vMarketsInfo[vMarketId];
                if (changedVirtualCategories[vCategoryId] === undefined) {
                    changedVirtualCategories[vCategoryId] = {
                        newMarkets: new Set(),
                        deletedMarkets: new Set(),
                    };
                }
                changedVirtualCategories[vCategoryId].deletedMarkets.add(vMarketId);
                continue;
            }
            if (updates.recalcOrder) {
                const { marketId } = vMarketsInfo[vMarketId].filteredBy;
                const orderedOutcomeTypes = (_d = (_c = marketsMap[marketId]) === null || _c === void 0 ? void 0 : _c.orderedOutcomeTypes) !== null && _d !== void 0 ? _d : [];
                tempMarketChanges.changedOrder = (0, getOrderedOutcomeKeys_1.getOrderedOutcomeKeys)({
                    vMarketInfo: vMarketsInfo[vMarketId],
                    orderedOutcomeTypes,
                    outcomes: draft,
                });
            }
            if (updates.recalcStatus) {
                const newStatus = (0, getCategoryMarketInfoFilteredTradingStatus_1.getOutcomesMarketTradingStatus)({
                    outcomes: Object.values(draft),
                    eventStatus,
                });
                const statusChanged = newStatus !== prevOutcomes.markets[vMarketId].tradingStatus;
                if (statusChanged) {
                    tempMarketChanges.statusChanged = true;
                    tempMarketChanges.changedTradingStatus = newStatus;
                }
            }
            changedMarkets[vMarketId] = tempMarketChanges;
        }
    }
    // Собираем маркеты помеченные как новые
    for (const [vMarketId, probabilities] of Object.entries(newVirtualMarkets)) {
        const { marketId } = vMarketsInfo[vMarketId].filteredBy;
        const orderedOutcomeTypes = (_f = (_e = marketsMap[marketId]) === null || _e === void 0 ? void 0 : _e.orderedOutcomeTypes) !== null && _f !== void 0 ? _f : [];
        const outcomes = (0, mapProbsToOutcomes_1.mapProbabilitiesToOutcomes)({
            probabilities,
            vMarketInfo: vMarketsInfo[vMarketId],
            players: args.playersMap,
            clientType: args.clientType,
            eventCompetitors: args.eventCompetitors,
            orderedOutcomeTypes,
        });
        newMarkets[vMarketId] = {
            vMarketId,
            vCategoryId: vMarketsInfo[vMarketId].vCategoryId,
            outcomesByKey: outcomes,
            outcomesOrder: (0, getOrderedOutcomeKeys_1.getOrderedOutcomeKeys)({
                vMarketInfo: vMarketsInfo[vMarketId],
                orderedOutcomeTypes,
                outcomes,
            }),
            tradingStatus: (0, getCategoryMarketInfoFilteredTradingStatus_1.getOutcomesMarketTradingStatus)({
                outcomes: Object.values(outcomes),
                eventStatus,
            }),
        };
    }
    // Проверяем изменения в категориях
    // У нас есть старые категории
    //  - не измененные
    //  - измененные
    //    - добавился маркет
    //    - удалился маркет
    let changedCategories;
    if (categoriesChanged) {
        const prev = prevCategories.reduce((acc, cur) => {
            acc[cur.vCategoryId] = cur;
            return acc;
        }, {});
        changedCategories = vCategoriesSortedIds.reduce((acc, vCategoryId) => {
            if (newVirtualCAtegories[vCategoryId]) {
                acc.push({
                    vCategoryId,
                    vMarketIds: orderMarkets(vCategoriesInfo[vCategoryId], newVirtualCAtegories[vCategoryId]),
                });
            }
            else if (changedVirtualCategories[vCategoryId]) {
                let curMarketIds = prev[vCategoryId].vMarketIds;
                if (changedVirtualCategories[vCategoryId].deletedMarkets.size > 0) {
                    curMarketIds = curMarketIds.filter((id) => !changedVirtualCategories[vCategoryId].deletedMarkets.has(id));
                }
                if (changedVirtualCategories[vCategoryId].newMarkets.size > 0) {
                    curMarketIds = orderMarkets(vCategoriesInfo[vCategoryId], new Set([
                        ...curMarketIds,
                        ...changedVirtualCategories[vCategoryId].newMarkets,
                    ]));
                }
                if (curMarketIds.length === 0) {
                    return acc;
                }
                acc.push({ vCategoryId, vMarketIds: curMarketIds });
            }
            else if (prev[vCategoryId]) {
                acc.push(prev[vCategoryId]);
            }
            return acc;
        }, []);
    }
    if (Object.keys(changedMarkets).length === 0 &&
        Object.keys(newMarkets).length === 0 &&
        deletedMarketsIds.size === 0 &&
        changedCategories === undefined) {
        return null;
    }
    return {
        changedMarkets,
        newMarkets,
        deletedMarketsIds,
        changedCategories,
    };
}
function orderMarkets(vCategoryInfo, ids) {
    return vCategoryInfo.orderedVirtualMarketIds.reduce((acc, cur) => {
        if (ids.has(cur)) {
            acc.push(cur);
        }
        return acc;
    }, []);
}
//# sourceMappingURL=handleStreamUpdatesV2.js.map